import { useNavigateToHome } from '@/hooks';
import Button from '@/storybook/components/Button/Button';
import { useTranslation } from 'react-i18next';
import Code404 from './Code404/Code404';
import styles from './NotFound.module.scss';

const NotFound = () => {
  const { t } = useTranslation();
  const navigateToHome = useNavigateToHome();

  return (
    <div className={styles.notFound}>
      <Code404 width={250} height={250} />
      <h2>{t('main.notFound.pageNotAvailable')}</h2>
      <p>{t('main.notFound.pageNotAvailableExplanation')}</p>
      <Button onClick={navigateToHome}>{t('main.notFound.backToHomepage')}</Button>
    </div>
  );
};

export default NotFound;
